import React from "react"
import Navigation from "./Navigation"

function Layout({ children }) {
  return (
    <div className="app-container bg-[#0a0a0a] text-gray-300 min-h-screen">
      <Navigation />
      <main className="main-content pt-16">{children}</main>
      <footer className="footer">
        <p>&copy; 2023 Multitalented Artist. All rights reserved.</p>
      </footer>
    </div>
  )
}

export default Layout
